import { useFeatureFlags } from '@node-space/hooks'

export interface WebhooksRequestConfig {
  baseUrl: string
  authenticated?: boolean
  config?: { withCredentials: boolean }
}

export const useWebhooksRequestConfig = (): WebhooksRequestConfig => {
  const { enableWebhooksBff } = useFeatureFlags()

  if (enableWebhooksBff) {
    return {
      baseUrl: process.env.VITE_BASE_URL ?? '',
      authenticated: true,
      config: { withCredentials: true },
    }
  }

  return { baseUrl: process.env.API_URL ?? '' }
}
